import React from 'react'
import { Grid } from '@mui/material'

import FormikDateField from '../../components/ui-widgets/FormikDateField'
import { type EditSolarProjectComponentProps } from './EditSolarProjectForm'

const EditSolarProjectLifecycleDates: React.FC<EditSolarProjectComponentProps> = ({
  project,
  overrideLockedFields
}: EditSolarProjectComponentProps) => {
  const isFormFieldLocked = (fieldName: string): boolean => {
    return !overrideLockedFields && project.lifecycleDates.isLocked
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid item md={12} sx={{ mt: 3 }}></Grid>

        {/* ==================================================================================================== */}

        <Grid item md={4}>
          <FormikDateField fieldName={'lifecycleDates.campaignEnds'}
                           label={'Campaign Ends'}
                           locked={isFormFieldLocked('lifecycleDates.campaignEnds')} />
        </Grid>

         <Grid item md={4}>
           <FormikDateField fieldName={'lifecycleDates.crowdsaleStartDate'}
                            label={'Crowdsale Start Date'}
                            locked={isFormFieldLocked('lifecycleDates.crowdsaleStartDate')} />
         </Grid>

        <Grid item md={4}>
          <FormikDateField fieldName={'lifecycleDates.crowdsaleEndDate'}
                           label={'Crowdsale End Date'}
                           locked={isFormFieldLocked('lifecycleDates.crowdsaleEndDate')} />
        </Grid>

        {/* /!* ==================================================================================================== *!/ */}

        <Grid item md={4}>
          <FormikDateField fieldName={'lifecycleDates.cellOwnerAgreementEffectiveDate'}
                           label={'Cell Owner Agreement Effective Date'}
                           locked={isFormFieldLocked('lifecycleDates.cellOwnerAgreementEffectiveDate')} />
        </Grid>

         <Grid item md={8}></Grid>

        {/* /!* ==================================================================================================== *!/ */}

        <Grid item md={4}>
          <FormikDateField fieldName={'lifecycleDates.earlyEnergyDate'}
                           label={'Early Energy Date'}
                           locked={isFormFieldLocked('lifecycleDates.earlyEnergyDate')} />
        </Grid>

        <Grid item md={4}>
          <FormikDateField fieldName={'lifecycleDates.assetLeaseCommercialOperationDate'}
                           label={'Asset Lease Commercial Operation Date'}
                           locked={isFormFieldLocked('lifecycleDates.assetLeaseCommercialOperationDate')} />
        </Grid>

        <Grid item md={4}>
          <FormikDateField fieldName={'lifecycleDates.supplierCommercialOperationDate'}
                           label={'Supplier Commercial Operation Date'}
                           locked={isFormFieldLocked('lifecycleDates.supplierCommercialOperationDate')} />
        </Grid>

        {/* ==================================================================================================== */}

      </Grid>
    </>
  )
}

export default EditSolarProjectLifecycleDates
